import { useQuery } from "@tanstack/react-query";
import { UseGetReportQueryOptions } from "./types";
import { getAgreementsService } from "./service";

export const getReportQueryKey = ["agreements"];

export function useGetReportQuery(
  options?: UseGetReportQueryOptions
) {

  return useQuery({
    queryKey: getReportQueryKey,
    queryFn: getAgreementsService,
    ...options,
  });
}
